import React from 'react';
import DOMPurify from 'dompurify';

/**
 * Custom HTML Block Renderer
 * Variants: default, full_width, contained
 */
export default function HtmlRenderer({ props, variant, isEditing }) {
  const {
    html_content = '<div style="padding:2rem;text-align:center;color:#78716c;">Paste your HTML here</div>',
    custom_css = '',
    max_width = 'full',
  } = props;

  const maxWidthStyle = max_width === 'contained'
    ? '1100px'
    : max_width === 'narrow'
    ? '800px'
    : '100%';

  const blockId = `html-blk-${Math.random().toString(36).slice(2, 8)}`;
  const sanitizedHtml = DOMPurify.sanitize(html_content, {
    ADD_TAGS: ['svg', 'path', 'circle', 'rect', 'line', 'polyline', 'polygon', 'g', 'defs', 'use', 'symbol'],
    ADD_ATTR: ['viewBox', 'xmlns', 'fill', 'stroke', 'stroke-width', 'd', 'cx', 'cy', 'r', 'rx', 'ry', 'x', 'y'],
    FORBID_TAGS: ['script', 'iframe'],
    FORBID_ATTR: ['onerror', 'onclick', 'onload', 'onmouseover', 'onfocus', 'onblur'],
  });

  const isEmpty = !html_content || html_content.trim() === '' ||
    html_content.includes('Paste your HTML here');

  return (
    <section className="py-6 px-4">
      <div
        className={blockId}
        style={{ maxWidth: maxWidthStyle, margin: '0 auto' }}
      >
        {custom_css && (
          <style dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(custom_css, { ALLOWED_TAGS: [] }) }} />
        )}
        {isEmpty && isEditing ? (
          <div className="flex flex-col items-center justify-center py-12 text-stone-400 border-2 border-dashed border-stone-200 rounded-lg">
            <svg className="w-8 h-8 mb-2" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.5}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M17.25 6.75L22.5 12l-5.25 5.25m-10.5 0L1.5 12l5.25-5.25m7.5-3l-4.5 16.5" />
            </svg>
            <span className="text-sm font-medium">Custom HTML Block</span>
            <span className="text-xs mt-1">Select this block to paste HTML</span>
          </div>
        ) : (
          <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />
        )}
      </div>
    </section>
  );
}
